module.exports = __webpack_public_path__ + "img/40_38_055_700.56de8a5b.jpg";